import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const user = JSON.parse(localStorage.getItem('user'));
const initial = user ? true : false;
const initialState = {
   
    branches:[],
    Toastmessage:'',
}
export const GlobalStore = createAsyncThunk('GlobalData', async (body) => {
})
const GlobalSlice = createSlice({

    name: 'GlobalData',
    initialState,
    reducers: {
        
        AddBranch:(state,action)=>{
            state.branches=action.payload
        },
        setToast:(state,action)=>{
            state.Toastmessage=action.payload
        },
        
    },
    extraReducers: {
        // register user
        [GlobalStore.pending]: (state) => {
            state.loading = true
            state.error = null
        },
        [GlobalStore.fulfilled]: (state, action) => {
            state.loading = false;
            state.email=action.meta.arg.email
            if(!action.payload.error && action?.payload?.data?.success_status){
                state.success=action?.payload?.data?.message;
                if(action.payload?.data?.access_token!== ''){
                    state.access_token = action?.payload?.data?.access_token
                }else{
                    state.error='Failed'
                }

                state.error=action.payload.message?.message
            }else{
                state.error=action?.payload?.data?.message
          
            }      },
        [GlobalStore.rejected]: (state, { payload }) => {
            state.loading = false
            state.error = payload?.message?.message
        },
    },
})
export const { AddBranch,setToast } = GlobalSlice.actions;
export default GlobalSlice.reducer